import { useEffect } from "react";
import mySongsLibrary from "../../../../services/songs/songsPage";
import {useAppSelector} from "../../../../redux/hooks";
import {mySongsLibraryStore} from "../my-songs-library-store/mySongsLibrary.store";


export const useMySongsLibraryConnectionLogic = () => {
  const isLibraryRequestReadyToSend = useAppSelector(mySongsLibraryStore.getIsRequestReadyToSend);
  useEffect(() => {
    // handle loading
    void mySongsLibrary.load();
    // not ready to unload, returned unload handler
    return () => mySongsLibrary.reset();
  }, [isLibraryRequestReadyToSend])
}
